import Button from './Button.view';

export default Button;
